import * as React from "react";
const SvgSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 8, height: 8, x: 0, y: 0, fill: "currentColor" }));
export default SvgSquare;
